import { resolveApiBaseUrl } from './api-base-url';

export const environment = {
  name: 'dev',
  production: false,
  apiBaseUrl: resolveApiBaseUrl(),
};
